const MAX_SIZE_IN_BYTES = 1024 * 1024 * 10; // 10MB

export const validateSize = (file: File): boolean => file.size <= MAX_SIZE_IN_BYTES;
